import { useQuery, useMutation, queryCache } from 'react-query'
import { PredictiveModelRepository } from 'repository/predictive-model'
import { PredictiveModelCreateParams, PredictiveModelUpdateParams } from 'models/predictive-model'

export const useFetchPredictiveModels = (options?: any) => {
  const { status, data: predictiveModels, error } = useQuery(
    'predictive-models',
    PredictiveModelRepository.fetchAll,
    options,
  )

  return {
    status,
    predictiveModels,
    error,
  }
}

export const useFetchPredictiveModel = (modelId: string, options?: any) => {
  const { status, predictiveModels, error } = useFetchPredictiveModels(options)
  const predictiveModel = predictiveModels?.find(
    (model) => parseInt(model.id) === parseInt(modelId),
  )

  return {
    status,
    predictiveModel,
    error,
  }
}

export const useCreatePredictiveModel = () => {
  return useMutation(
    (data: PredictiveModelCreateParams) => PredictiveModelRepository.create(data),
    {
      onSuccess: () => {
        queryCache.refetchQueries(['predictive-models'], { force: true })
      },
    },
  )
}

export const useUpdatePredictiveModel = (predictiveModelId: string) => {
  return useMutation(
    (data: PredictiveModelUpdateParams) =>
      PredictiveModelRepository.update(predictiveModelId, data),
    {
      onSuccess: () => {
        queryCache.refetchQueries(['predictive-models'], { force: true })
      },
    },
  )
}

export const useDeletePredictiveModel = (predictiveModelId: string) => {
  return useMutation(() => PredictiveModelRepository.delete(predictiveModelId), {
    onSuccess: () => {
      queryCache.refetchQueries(['predictive-models'], { force: true })
    },
  })
}

export const useGeneratePredictiveReport = (predictiveModelId: string) => {
  return useMutation(() => PredictiveModelRepository.generateReport(predictiveModelId), {
    onSuccess: () => {
      queryCache.refetchQueries(['organization'], { force: true })
    },
  })
}
